<div class="spinner-container" *ngIf="spinnerService.spinnerVisibility$ | async">
    <!-- <mat-spinner color="accent"></mat-spinner> -->
    <!-- <div class="round9"></div> -->
    <!-- <div class="round7"></div> -->
    <div class="d-flex justify-content-center p-3" *ngIf="spinnerService.spinnerVisibility$ | async">
        <div class="spinner-grow text-success" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <div class="spinner-grow text-danger ms-2" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <div class="spinner-grow text-warning ms-2" role="status">
            <span class="visually-hidden ">Loading...</span>
        </div>
        <div class="spinner-grow text-info ms-2" role="status">
            <span class="visually-hidden ">Loading...</span>
        </div>
    </div>
</div>
<router-outlet></router-outlet>
<!-- </div> -->
<!-- <app-footer></app-footer> -->